import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {DestinationCard as DestinationCardBase} from '@homeaway/react-card-types';
import {
    CAROUSEL_DATA_FIELDS,
    CAROUSEL_TYPES,
    EVENT_TYPES,
} from '../../../../utils/edap/edapEventsConstants';
import useEdapEvent from '../../../../hooks/useEdapEvent';
import useEdapEventLegacy from '../../../../hooks/useEdapEventLegacy';

import './DestinationCard.less';

export default function DestinationCard(props) {
    const edapEvents = useEdapEvent(CAROUSEL_TYPES.DESTINATION);
    const {destinationCardClickEvent} = useEdapEventLegacy();
    const {
        actionLocation,
        aspectRatio,
        cardIndex,
        classNames,
        clientRequestId,
        imageHref,
        destinationUrl,
        searchTermUuid,
        title,
        cardLinkTarget,
        target,
        subtitle,
        customCardClickHandler,
    } = props;

    const classnames = cx(classNames, {
        'recommended-hit__destination': true,
    });

    const clickHandler = (e) => {
        customCardClickHandler(e, cardIndex);
        edapEvents[EVENT_TYPES.SELECTED]({
            target,
            clientRequestId,
            cardIndex,
            [CAROUSEL_DATA_FIELDS.CAROUSEL_CHILD]: searchTermUuid,
        });
        destinationCardClickEvent(
            {
                eventlbsuuid: searchTermUuid,
                eventrefinements: `position:${cardIndex + 1}`,
            },
            actionLocation
        );
    };

    return (
        <div className={classnames} onClick={clickHandler}>
            <DestinationCardBase
                alt={title}
                aspectRatio={aspectRatio}
                title={title}
                imageUri={imageHref}
                clickUrl={destinationUrl}
                loadImage
                target={cardLinkTarget}
                subtitle={subtitle}
            />
        </div>
    );
}

DestinationCard.propTypes = {
    destinationUrl: PropTypes.string,
    imageHref: PropTypes.string,
    searchTermUuid: PropTypes.string,
    subLocation: PropTypes.string,
    target: PropTypes.string,
    cardLinkTarget: PropTypes.string,
    customCardClickHandler: PropTypes.func,
    breadcrumbs: PropTypes.arrayOf(
        PropTypes.shape({
            place: PropTypes.shape({
                name: PropTypes.shape({
                    simple: PropTypes.string,
                    full: PropTypes.string,
                }),
            }),
        })
    ),
};
